
// Position the content near the top left of the window so it
// cannot create scrollbars, and ensure it is hidden before it is positioned
// to avoid any potential flickering
export const DEFAULT_ARROW_STYLES = {}

// Set the initial position to be near the top left of the screen to prevent scrollbars from appearing
// and ensure that it is hidden to prevent any unwanted flickering
export const DEFAULT_TOOLTIP_STYLES = {
	left: 50,
	opacity: 0,
	top: 50
}
